import { useState } from 'react'
import Layout from 'shared/layouts/containers/Main'
import useInit from './hooks/useInit'
import DeleteModal from 'shared/components/DeleteModal'
import SendEmailModal from 'components/SendEmailModal'
import { apiUrls, defaultPageSize, settings, tableColumnWidths } from 'consts'
import getRows from './utils/getRows'
import {
  PagingState,
  SearchState,
  IntegratedFiltering,
  IntegratedPaging,
  IntegratedSorting,
  SortingState,
  SelectionState,
  IntegratedSelection,
} from '@devexpress/dx-react-grid'
import {
  Grid,
  SearchPanel,
  Table,
  TableColumnResizing,
  TableHeaderRow,
  Toolbar,
  TableSelection,
  PagingPanel,
} from '@devexpress/dx-react-grid-bootstrap4'
import { TableColumnWidthInfo } from '@devexpress/dx-react-grid/dist/dx-react-grid'
import getBrandContent from 'utils/getBrandContent'
import SearchPanelInput from 'shared/components/SearchPanelInput'
import Footer from 'shared/components/Footer'
import getPageSize from 'utils/getPageSize'
import unlockAccount from './utils/unlockAccount'

const SuperAdmins: React.FunctionComponent = () => {
  const [showOverlay, setShowOverlay] = useState<boolean>(true)
  const [rows, setRows] = useState<any>([])
  const [showModal, setShowModal] = useState<boolean>(false)
  const [deleteEntryId, setDeleteEntryId] = useState<boolean | number>(false)

  const [selectedSuperadminIndexes, setSelectedSuperadminIndexes] = useState<any>([])
  useState<boolean>(false)

  const columns: { name: string; title: string; encodeHtml?: boolean; getCellValue?: any }[] = [
    { name: 'id', title: 'ID' },
    { name: 'concatened', title: 'Name' },
    { name: 'phone', title: 'Phone' },
    { name: 'email', title: 'Email' },
    { name: 'status', title: 'Status' },
    { name: 'action', title: 'Actions', encodeHtml: false },
  ]

  const columnWidths: TableColumnWidthInfo[] = [
    { columnName: 'id', width: tableColumnWidths.id },
    { columnName: 'concatened', width: 'auto' },
    { columnName: 'phone', width: 'auto' },
    { columnName: 'email', width: 'auto' },
    { columnName: 'status', width: 'auto' },
    { columnName: 'action', width: tableColumnWidths.three_actions },
  ]

  useInit({
    getRows,
    setRows,
    setDeleteEntryId,
    setShowModal,
    setShowOverlay,
    unlockAccount,
  })

  const TableComponent = ({ ...restProps }) => (
    <Table.Table {...restProps} className='with-action' />
  )

  const SearchPanelInputComponent = (props) => {
    return SearchPanelInput({
      addUrl: '/add-superadmin',
      addText: 'Add Superadmin',
      inputProps: props,
    })
  }

  const PagingContainer = (props) => {
    return <PagingPanel.Container {...props} className='table-footer' />
  }

  return (
    <Layout 
      footerContent={<Footer />} 
      brandContent={getBrandContent()} 
      showMinimizedBarButton={true}
      showOverlay={showOverlay}
    >
      <>
        <Grid rows={rows} columns={columns}>
          <SortingState defaultSorting={[{ columnName: 'email', direction: 'asc' }]} />
          <SearchState defaultValue='' />
          <IntegratedFiltering />
          <IntegratedSorting />
          <Toolbar />
          <SearchPanel inputComponent={SearchPanelInputComponent} />
          <PagingState
            defaultCurrentPage={0}
            defaultPageSize={getPageSize(settings.pageSizeSuperadmins)}
          />
          <IntegratedPaging />
          <Table tableComponent={TableComponent} />
          <TableColumnResizing defaultColumnWidths={columnWidths} resizingMode='nextColumn' />
          <TableHeaderRow showSortingControls />
          <PagingPanel pageSizes={[]} containerComponent={PagingContainer} />
        </Grid>
        <DeleteModal
          url={apiUrls.superadmins}
          showModal={showModal}
          setShowModal={setShowModal}
          deleteEntryId={deleteEntryId}
          setDeleteEntryId={setDeleteEntryId}
          entityName='Superadmin'
          getRows={getRows}
          setRows={setRows}
        />
      </>
    </Layout>
  )
}

export default SuperAdmins
